// import css from "./order.module.css";
// import { HandySvg } from "handy-svg";
// import iconSrc from "../../svg/deleteSrc.svg";
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import transliterate from "../../function/transliterate";

// export default function ProductInOrder({
//   el,
//   handleQuantityChange,
//   removeProduct,
// }) {
//   const navigate = useNavigate();
//   const [countProd, setCountProd] = useState(el.quantity);

//   const changeStateDown = () => {
//     if (countProd > 1) {
//       const newCount = countProd - 1;
//       setCountProd(newCount);
//       handleQuantityChange(el.uid, newCount);
//     }
//   };

//   const changeStateUp = () => {
//     const newCount = countProd + 1;
//     setCountProd(newCount);
//     handleQuantityChange(el.uid, newCount);
//   };

//   const sendToProduct = () => {
//     navigate(`/product/${transliterate(el.bookName)}`);
//   };

//   const hasFixedSale = el.priceSale && el.priceSale !== "";
//   const hasActionDiscount =
//     el.actionDiscountPercent && Number(el.actionDiscountPercent) > 0;

//   const finalPrice = hasFixedSale
//     ? Number(el.priceSale)
//     : hasActionDiscount
//     ? Math.round(el.price - (el.price * el.actionDiscountPercent) / 100)
//     : Number(el.price);

//   const isDiscounted = hasFixedSale || hasActionDiscount;

//   return (
//     <div className={css.prodInCardWrap}>
//       <img src={el.imageList[0]} className={css.bookFoto} alt={el.bookName} />

//       <div className={css.prodInfoWrap}>
//         <div className={css.wrapAllKD}>
//           <h1 className={css.booksNameCard} onClick={sendToProduct}>
//             {el.bookName}
//           </h1>
//           <div className={css.delete} onClick={() => removeProduct(el.uid)}>
//             <HandySvg src={iconSrc} width="25" height="29" />
//           </div>
//         </div>
//         <div className={css.descBookInOrder}>
//           <div className={css.blockProperty}>Українська</div>
//           <div className={css.blockProperty}>Паперова</div>
//         </div>

//         <div className={css.counterWrap}>
//           <div className={css.countPlusMinusValue}>
//             <div className={css.minus} onClick={changeStateDown}>
//               -
//             </div>
//             <div className={css.countValue}>{countProd}</div>
//             <div className={css.plus} onClick={changeStateUp}>
//               +
//             </div>
//           </div>
//           <div className={css.priceBlock}>
//             {isDiscounted && (
//               <div className={css.twoSpanIdn}>
//                 <span className={css.oldPrice}>{el.price}</span>{" "}
//                 <span className={css.priceSpan}>грн</span>
//               </div>
//             )}
//             <h4 className={isDiscounted ? css.priceRed : css.price}>
//               {finalPrice} <span className={css.priceSpan}>грн</span>
//             </h4>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import css from "./order.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../svg/deleteSrc.svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import transliterate from "../../function/transliterate";

export default function ProductInOrder({
  el,
  handleQuantityChange,
  removeProduct,
}) {
  const navigate = useNavigate();
  const [countProd, setCountProd] = useState(el.quantity);

  const changeStateDown = () => {
    if (countProd > 1) {
      const newCount = countProd - 1;
      setCountProd(newCount);
      handleQuantityChange(el.uid, newCount);
    }
  };

  const changeStateUp = () => {
    const newCount = countProd + 1;
    setCountProd(newCount);
    handleQuantityChange(el.uid, newCount);
  };

  const sendToProduct = () => {
    navigate(`/product/${transliterate(el.bookName)}`);
  };

  // const hasBundleDiscount =
  //   el.bundleDiscountPercent && Number(el.bundleDiscountPercent) > 0;
  // const hasFixedSale = el.priceSale && el.priceSale !== "";
  // const hasActionDiscount =
  //   el.actionDiscountPercent && Number(el.actionDiscountPercent) > 0;

  // let finalPrice = el.price;

  // if (hasBundleDiscount) {
  //   finalPrice = Math.round(
  //     el.price - (el.price * el.bundleDiscountPercent) / 100
  //   );
  // } else if (hasFixedSale) {
  //   finalPrice = Number(el.priceSale);
  // } else if (hasActionDiscount) {
  //   finalPrice = Math.round(
  //     el.price - (el.price * el.actionDiscountPercent) / 100
  //   );
  // }

  // const isDiscounted = hasFixedSale || hasActionDiscount || hasBundleDiscount;
  const hasFixedSale = el.priceSale && el.priceSale !== "";
  const hasBundleDiscount =
    el.bundleDiscountPercent && Number(el.bundleDiscountPercent) > 0;
  const hasActionDiscount =
    el.actionDiscountPercent && Number(el.actionDiscountPercent) > 0;

  let finalPrice = el.price;
  let originalPrice = null;

  if (el.sale === "true" && hasFixedSale) {
    finalPrice = Number(el.price); // Червона ціна — звичайна
    originalPrice = Number(el.priceSale); // Перекреслена — стара ціна
  } else if (hasFixedSale) {
    finalPrice = Number(el.priceSale); // Червона — знижка
    originalPrice = Number(el.price); // Перекреслена — стара
  } else if (hasBundleDiscount) {
    finalPrice = Math.round(
      el.price - (el.price * el.bundleDiscountPercent) / 100
    );
    originalPrice = el.price;
  } else if (hasActionDiscount) {
    finalPrice = Math.round(
      el.price - (el.price * el.actionDiscountPercent) / 100
    );
    originalPrice = el.price;
  }

  const isDiscounted = originalPrice !== null && finalPrice < originalPrice;

  return (
    <div className={css.prodInCardWrap}>
      <img src={el.imageList[0]} className={css.bookFoto} alt={el.bookName} />

      <div className={css.prodInfoWrap}>
        <div className={css.wrapAllKD}>
          <h1 className={css.booksNameCard} onClick={sendToProduct}>
            {el.bookName}
          </h1>
          <div className={css.delete} onClick={() => removeProduct(el.uid)}>
            <HandySvg src={iconSrc} width="25" height="29" />
          </div>
        </div>
        <div className={css.descBookInOrder}>
          <div className={css.blockProperty}>Українська</div>
          <div className={css.blockProperty}>Паперова</div>
        </div>

        <div className={css.counterWrap}>
          <div className={css.countPlusMinusValue}>
            <div className={css.minus} onClick={changeStateDown}>
              -
            </div>
            <div className={css.countValue}>{countProd}</div>
            <div className={css.plus} onClick={changeStateUp}>
              +
            </div>
          </div>
          {/* <div className={css.priceBlock}>
            {isDiscounted && (
              <div className={css.twoSpanIdn}>
                <span className={css.oldPrice}>{el.price}</span>{" "}
                <span className={css.priceSpan}>грн</span>
              </div>
            )}
            <h4 className={isDiscounted ? css.priceRed : css.price}>
              {finalPrice} <span className={css.priceSpan}>грн</span>
            </h4>
          </div> */}
          {el.sale !== "true" && (
            <div className={css.priceBlock}>
              {isDiscounted && (
                <div className={css.twoSpanIdn}>
                  <span className={css.oldPrice}>{el.price}</span>{" "}
                  <span className={css.priceSpan}>грн</span>
                </div>
              )}
              <h4 className={isDiscounted ? css.priceRed : css.price}>
                {finalPrice} <span className={css.priceSpan}>грн</span>
              </h4>
            </div>
          )}
          {el.sale === "true" && (
            <div className={css.priceBlock}>
              {isDiscounted && (
                <div className={css.twoSpanIdn}>
                  <span className={css.oldPrice}>{el.priceSale}</span>{" "}
                  <span className={css.priceSpan}>грн</span>
                </div>
              )}
              <h4 className={isDiscounted ? css.priceRed : css.price}>
                {el.price} <span className={css.priceSpan}>грн</span>
              </h4>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
